<template>
  <div>
    <Button
        class="order-progress-button"
        @frameworkButtonClicked="showModal = true"
        :color="getColors.defaultColorOutlineButton"
        :backgroundColor="getColors.defaultBackgroundColorOutlineButton"
        :size="'small'"
        :outline="true"
        :width="'258px'">
      <template #button-content>
        <div class="double-texted-button">
          <div class="upper-double-texted-button-text">{{ $t('shortStops.korteStops') }}</div>
          <div class="lower-double-texted-button-text">{{ $t('ui.verklaren') }}</div>
        </div>
        <i class="far double-texted-button-icon fa-clock"></i>
      </template>
    </Button>
    <div v-if="showModal" class="modal fade show d-block" tabindex="-1" role="dialog" style="background-color: rgba(0,0,0,0.5);">
      <ShortStopsModal @close="showModal = false" @saved="refreshShortStopsData"/>
    </div>
  </div>
</template>

<script>
import ShortStopsModal from "@/components/shortStops/ShortStopsModal.vue";
import Button from "@/components/ui/Button.vue";
import colors from "@/assets/scss/MotivateColors.scss";
import {mapGetters} from "vuex";

export default {
  components: { ShortStopsModal, Button },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    ...mapGetters('users', ['getSelectedWorkflow', 'getClaims']),
    getColors() {
      return colors;
    },
  },
  methods: {
    async refreshShortStopsData() {
      const moment = require('moment');
      try {
        await this.$store.dispatch('shortStops/closeDBChannel', { clearModule: true });
      } catch (e) {
        // Channel might not be open, ignore
      }

      const selectedDate = new Date();
      let where = [
        ['companyId', '==', this.getClaims.companyId],
        ['workflowId', '==', this.getSelectedWorkflow],
        ['start', '>=', moment(selectedDate).startOf('day').toDate()],
        ['start', '<=', moment(selectedDate).endOf('day').toDate()]
      ];

      try {
        await this.$store.dispatch('shortStops/openDBChannel', { where });
        // Also fetch declarations to get declaredBy info
        await this.$store.dispatch('shortStopDeclarations/fetchAndAdd', {
          where: [
            ['companyId', '==', this.getClaims.companyId],
            ['workflowId', '==', this.getSelectedWorkflow]
          ]
        });
      } catch (e) {
        console.log('ShortStops fetch error:', e);
      }
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .framework-button {
  margin-right: 14px;
}

.upper-double-texted-button-text {
  font-size: 24px;
  font-weight: 600;
  text-align: left;
}

.lower-double-texted-button-text {
  font-size: 18px;
  text-align: left;
  font-weight: 500;
}

.double-texted-button-icon {
  font-size: 32px;
}
</style>
